// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-menu--collapse .el-menu .el-submenu,\n.el-menu--popup {\n  min-width: 116px !important;\n  background: #FFFFFF !important;\n  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.19) !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
